<template>
    <Badge :color="statusVariant">
        {{ statusText }}
    </Badge>
</template>

<script>
import Badge from '@/components/redesigned/Badge'

export default {
    name: 'LsvaDeclarationStatusBadge',
    components: {
        Badge,
    },
    props: {
        declaration: {
            type: Object,
            required: true,
        },
    },
    computed: {
        statusText() {
            const {
                has_manual_corrections,
                needs_manual_correction,
                needs_manual_correction_cause,
            } = this.declaration

            if (!needs_manual_correction && !has_manual_corrections) {
                return this.$t('recorded')
            }

            if (!needs_manual_correction && has_manual_corrections) {
                return this.$t('corrected')
            }

            if (needs_manual_correction) {
                switch (needs_manual_correction_cause) {
                    case 'CONNECTION_LOST':
                    case 'CONNECTION_LOST_ON_NEXT_DAY':
                        return this.$t('noConnection')
                    case 'NOT_INSTALLED':
                        return this.$t('notInstalled')
                    case 'INSTALLATION_DATE':
                        return this.$t('installationDate')
                    case 'GPS_ISSUE':
                        return this.$t('gpsIssue')
                }
            }
            return this.$t('unknown')
        },
        statusVariant() {
            const {
                has_manual_corrections,
                needs_manual_correction,
                needs_manual_correction_cause,
            } = this.declaration

            if (!needs_manual_correction && !has_manual_corrections) {
                return 'disabled'
            }
            if (!needs_manual_correction && has_manual_corrections) {
                return 'primary'
            }
            if (needs_manual_correction) {
                if (
                    [
                        'CONNECTION_LOST',
                        'CONNECTION_LOST_ON_NEXT_DAY',
                        'NOT_INSTALLED',
                        'INSTALLATION_DATE',
                    ].includes(needs_manual_correction_cause)
                ) {
                    return 'danger'
                }
                if (needs_manual_correction_cause === 'GPS_ISSUE') {
                    return 'warning'
                }
            }

            return 'default'
        },
    },
}
</script>

<i18n>
{
    "en": {
        "corrected": "Corrected",
        "installationDate": "Installation date",
        "noConnection": "No connection",
        "notInstalled": "Not installed",
        "recorded": "Recorded",
        "gpsIssue": "GPS Issue",
        "unknown": "Unknown"
    },
    "de": {
        "corrected": "Korrigiert",
        "installationDate": "Installationsdatum",
        "noConnection": "Keine Verbindung",
        "notInstalled": "Nicht eingebaut",
        "recorded": "Aufgezeichnet",
        "gpsIssue": "GPS-Problem",
        "unknown": "Unbekannt"
    },
    "fr": {
        "corrected": "Corrigé",
        "installationDate": "Date d'installation",
        "noConnection": "Pas de connexion",
        "notInstalled": "Non installé",
        "recorded": "Enregistré",
        "gpsIssue": "Problème GPS",
        "unknown": "Inconnu"
    },
    "it": {
        "corrected": "Corretto",
        "installationDate": "Data di installazione",
        "noConnection": "Nessuna connessione",
        "notInstalled": "Non installato",
        "recorded": "Registrato",
        "gpsIssue": "Problema GPS",
        "unknown": "Sconosciuto"
    }

}
</i18n>
